import { spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  disclaimer: {
    flexDirection: "row",
    alignItems: "center",
  },
  disclaimerInner: {
    marginLeft: spacing.m,
  },
};
